"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EhubMessages = void 0;
var EhubMessages;
(function (EhubMessages) {
    EhubMessages["EHUB_LOADED"] = "EHUB_LOADED";
    EhubMessages["EHUB_START_GAME"] = "EHUB_START_GAME";
})(EhubMessages = exports.EhubMessages || (exports.EhubMessages = {}));
